import AvgTransactionsCountCard from "./NumberCards/AvgTransactionStats/AvgTransactionsCount";
import TransactionFinancialCard from "./NumberCards/TransactionFinancial/TransactionFinancialCard";
import Period from "./Period";
import TransactionNumberCard from "./NumberCards/TransactionNumberCard";
import NotifyNumberCard from "./NumberCards/NotifyNumber/NotifyNumberCard";
import DeviceLastStatusCard from "./NumberCards/DevicesStatus/DeviceLastStatusCard";
import DeviceStatusCard from "./NumberCards/DevicesStatus/DeviceStatusCard";
import TransactionsLineChart from "./Graphs/TransactionLineCharts/TransactionsLineChart";
import DeviceMonitoringPieChart from "./Graphs/DevicePieCharts/DeviceMonitoringPieChart";
import DeviceTemperatureCarousel from "./DeviceTemperature/DeviceTemperatureCarousel";

export const analysisStats = {
    TransactionFinancialCard,
    Period,
    TransactionNumberCard,
    DeviceLastStatusCard,
    DeviceStatusCard,
    NotifyNumberCard,
    AvgTransactionsCountCard,
    TransactionsLineChart,
    DeviceTemperatureCarousel
};

export const deviceAnalysisStats = {
    DeviceMonitoringPieChart
}
